export default {
    "data": {
        "h5": {
            "imgList": [
                "https://s21.lgstatic.com/growth/activity/20220415/1650011491193.png",
                "https://s21.lgstatic.com/growth/activity/20220415/1650011501129.png",
                "https://s20.lgstatic.com/growth/activity/20220415/1650011513540.png",
                "https://s21.lgstatic.com/growth/activity/20220415/1650011525606.png",
                "https://s21.lgstatic.com/growth/activity/20220415/1650011538647.png",
                "https://s21.lgstatic.com/growth/activity/20220415/1650011558158.png",
                "https://s21.lgstatic.com/growth/activity/20220415/1650011571562.png",
                // "https://s21.lgstatic.com/growth/activity/20210816/1629094814710.png",
                // "https://s20.lgstatic.com/growth/activity/20210816/1629094891105.png",
                // "https://s21.lgstatic.com/growth/activity/20210816/1629094912520.png",
                // "https://s21.lgstatic.com/growth/activity/20210816/1629094925010.png"
            ],
            "btnImg": {
                "receive": "",
                "footer": "https://s21.lgstatic.com/growth/activity/20210816/1629094985314.png",
                "getmore": ""
            },
            "tabImgList": [
                {
                    "title": "",
                    "desc": ""
                }, {
                    "title": "",
                    "desc": ""
                }, {
                    "title": "",
                    "desc": ""
                }, {
                    "title": "",
                    "desc": ""
                }
            ]
        },
        "pc": {
            "imgList": [
                "https://s20.lgstatic.com/growth/activity/20220418/1650270769366.png",
                "https://s21.lgstatic.com/growth/activity/20220418/1650270778424.png",
                "https://s20.lgstatic.com/growth/activity/20220418/1650270788882.png",
                "https://s20.lgstatic.com/growth/activity/20220418/1650270798079.png",
                "https://s21.lgstatic.com/growth/activity/20220418/1650270807415.png",
                "https://s20.lgstatic.com/growth/activity/20220418/1650270817236.png",
                "https://s21.lgstatic.com/growth/activity/20220418/1650270827782.png",
                "https://s21.lgstatic.com/growth/activity/20220418/1650270936627.png",
                // "https://s20.lgstatic.com/growth/activity/20210816/1629107574921.png",
                // "https://s20.lgstatic.com/growth/activity/20210818/1629258711694.png",
                // "https://s21.lgstatic.com/growth/activity/20210816/1629107605215.png"
            ],
            "tabImgList": [
                {
                    "title": "",
                    "desc": ""
                }, {
                    "title": "",
                    "desc": ""
                }, {
                    "title": "",
                    "desc": ""
                }, {
                    "title": "项目四",
                    "desc": ""
                }
            ],
            "btnImg": {
                "receive": "",
                "footer": "https://s21.lgstatic.com/growth/activity/20220418/1650270958590.png",
                "stageMore": "https://s21.lgstatic.com/growth/activity/20210817/1629167302646.png"
            }
        },
        "tabMain": {
            "h5titleImg": "",
            "pctitleImg": "https://s21.lgstatic.com/growth/activity/20210817/1629164978932.png",
            "stageList": [
                {
                    "stage": "第一阶段",
                    "title": "产品思维篇",
                    "phaseTargetList": [
                        "对产品有深入认知，拥有产品思维",
                        "清晰产品经理的核心工作内容与价值",
                        "能独立规划行业目标、职业发展方向"
                    ],
                    "skillsList": {
                        "left": [
                            "我能成为一名产品经理吗？",
                            "明晰产品经理的核心价值",
                            "互联网时代发展下的产品能力进阶",
                            "拆解专业大厂产品经理工作流",
                        ],
                        "right": [
                            "0基础小白的产品经理通关指南",
                            "认识产品之产品构成三要素",
                            "运用三重视角塑造产品思维",
                            "谱写互联网产品的生命之旅",
                        ]
                    },
                    "tips": [
                        "设定目标岗位、制定对应的职业发展路径"
                    ],
                    "details": [
                        {
                            "t": "破局：全方位了解产品经理岗位",
                            "desc": [
                                "我能成为一名产品经理吗？",
                                "明晰产品经理的核心价值"
                            ]
                        }, {
                            "t": "入圈：成为新时代的高端稀缺人才",
                            "desc": [
                                "互联网时代发展下的产品能力进阶",
                                "拆解专业大厂产品经理工作流",
                                "0基础小白的产品经理通关指南"
                            ]
                        }, {
                            "t": "重塑：结构化打造专属产品思维",
                            "desc": [
                                "认识产品之产品构成三要素",
                                "运用三重视角塑造产品思维",
                                "谱写互联网产品的生命之旅",
                            ]
                        }, {
                            "t": "应用实战",
                            "desc": [
                                "设定目标岗位、制定对应的职业发展路径"
                            ]
                        }
                    ]
                },
                {
                    "stage": "第二阶段",
                    "title": "战略思维篇（上）",
                    "phaseTargetList": [
                        "打造产品全局观，从商业角度看产品",
                        "了解B、C端产品的经典商业模式",
                        "掌握用业务逻辑图拆解企业业务逻辑"
                    ],
                    "skillsList": {
                        "left": [
                            "解析什么是产品的商业模式",
                            "打造产品经理必备的商业化思维",
                            "详解互联网产品五大经典商业模式",
                            "剖析B、C端商业模式的差异化",
                        ],
                        "right": [
                            "通过业务逻辑图了解企业的运转逻辑",
                            "实战：核心三要素搭建业务逻辑图",
                            "案例：广告产品的业务逻辑图拆解"
                        ]
                    },
                    "tips": [
                        "用业务逻辑图拆解目标行业的商业模式"
                    ],
                    "details": [
                        {
                            "t": "商业思维：产品能力天花板的决定因素",
                            "desc": [
                                "解析什么是产品的商业模式",
                                "打造产品经理必备的商业化思维"
                            ]
                        }, {
                            "t": "商业模式：创造产品价值的核心运营机制",
                            "desc": [
                                "详解互联网产品五大经典商业模式",
                                "剖析B、C端商业模式的差异化"
                            ]
                        }, {
                            "t": "探索业务：学会使用业务逻辑图拆解商业模式",
                            "desc": [
                                "通过业务逻辑图了解企业的运转逻辑",
                                "善用核心三要素搭建业务逻辑图",
                                "案例：广告产品的业务逻辑图拆解"
                            ]
                        }, {
                            "t": "应用实战",
                            "desc": [
                                "用业务逻辑图拆解目标行业的商业模式"
                            ]
                        }
                    ]
                },
                {
                    "stage": "第三阶段",
                    "title": "战略思维篇（下）",
                    "phaseTargetList": [
                        "可以独立对目标行业进行行业分析",
                        "了解产品的竞争格局，看懂竞争策略",
                        "能在产品的不同阶段进行有效竞品分析"
                    ],
                    "skillsList": {
                        "left": [
                            "明晰行业分析在产品设计中的作用",
                            "案例：美团外卖的行业分析应用",
                            "详解互联网产品五大经典商业模式",
                            "通过行业地图找到行业价值链",
                            "详细梳理一份行业上下游地图",
                            "结构化四层法产出行业分析报告",
                            "如何将行业分析报告应用到实际业务",
                            "常谈的竞品分析究竟是什么",
                            "解析竞品分析的目的和作用",
                        ],
                        "right": [
                            "两个维度衡量竞品间的竞争强度",
                            "判别直接竞品、间接竞品、潜在竞品",
                            "波特五力法破解产品竞争格局",
                            "拓展：竞品信息、数据检索神器",
                            "五层框架法拆解竞品分析核心要素",
                            "如何做高匹配的竞品分析报告",
                        ]
                    },
                    "tips": [
                        "对目标行业产品进行行业分析及竞品分析，并产出分析报告"
                    ],
                    "details": [
                        {
                            "t": "入行必备：通晓行业经营之道成为行内人",
                            "desc": [
                                "明晰行业分析在产品设计中的作用",
                                "案例：美团外卖的行业分析应用"
                            ]
                        }, {
                            "t": "高纬俯瞰：应用行业地图分析宏观产业链",
                            "desc": [
                                "通过行业地图找到行业价值链",
                                "详细梳理一份行业上下游地图",
                            ]
                        }, {
                            "t": "躬行实践：行业分析与产品业务的双向结合",
                            "desc": [
                                "结构化四层法产出行业分析报告",
                                "如何将行业分析报告应用到实际业务"
                            ]
                        }, {
                            "t": "洞若观火：互联网高竞争环境的竞品研究",
                            "desc": [
                                "常谈的竞品分析究竟是什么",
                                "解析竞品分析的目的和作用"
                            ]
                        }, {
                            "t": "明辨笃行:于竞争中找到产品的生存指南",
                            "desc": [
                                "两个维度衡量竞品间的竞争强度",
                                "判别直接竞品、间接竞品、潜在竞品",
                                "波特五力法破解产品竞争格局",
                                "拓展：竞品信息、数据检索神器"
                            ]
                        }, {
                            "t": "知己知彼：不同阶段下的有效竞品分析",
                            "desc": [
                                "五层框架法拆解竞品分析核心要素",
                                "如何做高匹配的竞品分析报告"
                            ]
                        }, {
                            "t": "应用实战",
                            "desc": [
                                "对目标行业产品进行行业分析及竞品分析，并产出分析报告"
                            ]
                        }
                    ]
                },
                {
                    "stage": "第四阶段",
                    "title": "用户研究篇",
                    "phaseTargetList": [
                        "清楚用户研究的意义，了解不同产品用户的区别",
                        "掌握B、C端产品用户调研的方法和工具",
                        "掌握用户画像的设计与实际应用"
                    ],
                    "skillsList": {
                        "left": [
                            "剖析用户研究的重要意义和作用",
                            "用户型产品与业务性产品的用户研究",
                            "用户型产品的用户研究全流程",
                            "用户型产品定性与定量用户调查",
                            "构建用户画像：persona与profile",
                        ],
                        "right": [
                            "客户研究指导业务型产品设计",
                            "三步法甄选和分析调研对象",
                            "B端客户调研的方法和工具",
                            "案例：AI导航产品的客户调研",
                        ]
                    },
                    "tips": [
                        "规划目标行业产品用户研究方案并实施"
                    ],
                    "details": [
                        {
                            "t": "量体裁衣：多维度研究产品的目标用户/客户",
                            "desc": [
                                "剖析用户研究的重要意义和作用",
                                "用户型产品与业务性产品的用户研究"
                            ]
                        }, {
                            "t": "用户洞察：C端用户型产品的用户研究方法",
                            "desc": [
                                "用户型产品的用户研究全流程",
                                "用户型产品定性与定量用户调查",
                                "构建用户画像：persona与profile"
                            ]
                        }, {
                            "t": "客户挖掘：B端业务型产品的客户研究方法",
                            "desc": [
                                "客户研究指导业务型产品设计",
                                "三步法甄选和分析调研对象",
                                "B端客户调研的方法和工具",
                                "案例：AI导航产品的客户调研"
                            ]
                        }, {
                            "t": "应用实战",
                            "desc": [
                                "规划目标行业产品用户研究方案并实施"
                            ]
                        }
                    ]
                },
                {
                    "stage": "第五阶段",
                    "title": "需求分析篇",
                    "phaseTargetList": [
                        "能够对产品的需求做决策，对需求进行合理管理",
                        "应用5w1h、问题结构四要素找到用户底层需求",
                        "应用hmw、价值主张画布将需求转化为解决方案"
                    ],
                    "skillsList": {
                        "left": [
                            "需求的定义及需求的组织结构",
                            "B、C端获取用户需求的渠道详解",
                            "九大方向主动挖掘用户需求",
                            "5w1h法做需求的去伪存真",
                            "用hmw分析法进行需求转化",
                            "价值主张画布产出有价值的解决方案",
                            "拓展：四要素解构用户问题找到底层需求",
                        ],
                        "right": [
                            "两大排序法：重要紧急四象限、ICE",
                            "需求池，高效管理产品需求的工具",
                            "C端新零售行业需求分析案例拆解",
                            "B端全平台系统需求分析案例拆解",
                        ]
                    },
                    "tips": [
                        "研究目标行业产品解决的用户场景、用户底层需求"
                    ],
                    "details": [
                        {
                            "t": "擘两分星：通过需求分析精准解决用户问题",
                            "desc": [
                                "需求的定义及需求的组织结构",
                                "B、C端获取用户需求的渠道详解"
                            ]
                        }, {
                            "t": "全流程诠释：从用户需求到解决方案",
                            "desc": [
                                "九大方向主动挖掘用户需求",
                                "5w1h法做需求的去伪存真",
                                "用hmw分析法进行需求转化",
                                "价值主张画布产出有价值的解决方案",
                                "拓展：四要素解构用户问题找到底层需求"
                            ]
                        }, {
                            "t": "需求排序：掌握需求的高级动态管理",
                            "desc": [
                                "两大排序法：重要紧急四象限、ICE",
                                "需求池，高效管理产品需求的工具"
                            ]
                        }, {
                            "t": "实战演绎：需求分析的应用案例拆解",
                            "desc": [
                                "C端新零售行业需求分析案例拆解",
                                "B端全平台系统需求分析案例拆解"
                            ]
                        }, {
                            "t": "应用实战",
                            "desc": [
                                "研究目标行业产品解决的用户场景、用户底层需求"
                            ]
                        }
                    ]
                },
                {
                    "stage": "第六阶段",
                    "title": "产品设计篇",
                    "phaseTargetList": [
                        "掌握产品设计的标准流程，学习不同产品的产品设计",
                        "能够独立设计产品流程，规划用户路线",
                        "能够独立设计产品架构，搭建产品全局框架"
                    ],
                    "skillsList": {
                        "left": [
                            "拆解大厂产品设计的标准流程",
                            "4层4D法高效完成产品设计",
                            "使用结构图搭建产品全局框架",
                            "使用流程图梳理产品业务流程",
                        ],
                        "right": [
                            "梳理产品功能列表的核心诀窍",
                            "重用户体验的C端产品设计（每日优鲜）",
                            "重业务逻辑的B端CRM系统设计",
                        ]
                    },
                    "tips": [
                        "完成目标行业产品的业务流程图、产品结构图、功能列表"
                    ],
                    "details": [
                        {
                            "t": "硬核能力： 必备的产品设计基本功",
                            "desc": [
                                "拆解大厂产品设计的标准流程",
                                "4层4D法高效完成产品设计"
                            ]
                        }, {
                            "t": "两图一表：完美理清产品整体框架",
                            "desc": [
                                "使用结构图搭建产品全局框架",
                                "使用流程图梳理产品业务流程",
                                "梳理产品功能列表的核心诀窍",
                            ]
                        }, {
                            "t": "实战演绎：产品设计的应用案例拆解",
                            "desc": [
                                "重用户体验的C端产品设计（每日优鲜）",
                                "重业务逻辑的B端CRM系统设计"
                            ]
                        }, {
                            "t": "应用实战",
                            "desc": [
                                "完成目标行业产品的业务流程图、产品结构图、功能列表"
                            ]
                        }
                    ]
                },
                {
                    "stage": "第七阶段",
                    "title": "产品方案篇",
                    "phaseTargetList": [
                        "掌握产品原型与交互设计的要点",
                        "学会使用两大产品设计工具：axure、墨刀",
                        "掌握产品经理必备文档：产品需求文档"
                    ],
                    "skillsList": {
                        "left": [
                            "产品原型与页面设计要点",
                            "axure、墨刀的基础操作流",
                            "工具页面与基础功能介绍",
                            "原型的页面跳转交互原理",
                        ],
                        "right": [
                            "三大产品文档的工作应用场景",
                            "BRD、MRD、PRD的文档规范",
                            "详细拆解优秀的产品需求文档PRD",
                        ]
                    },
                    "tips": [
                        "完成目标行业产品的产品需求文档PRD"
                    ],
                    "details": [
                        {
                            "t": "效果呈现：利用原型完成产品构想的可视化",
                            "desc": [
                                "产品原型与页面设计要点"
                            ]
                        }, {
                            "t": "工具运用：axure、墨刀的使用教程",
                            "desc": [
                                "axure、墨刀的基础操作流",
                                "工具页面与基础功能介绍",
                                "原型的页面跳转交互原理"
                            ]
                        }, {
                            "t": "落地成果：产出高质量的产品文档",
                            "desc": [
                                "三大产品文档的工作应用场景",
                                "BRD、MRD、PRD的文档规范"
                            ]
                        }, {
                            "t": "实战演绎：产品需求文档的实操应用",
                            "desc": [
                                "详细拆解优秀的产品需求文档PRD"
                            ]
                        }, {
                            "t": "应用实战",
                            "desc": [
                                "完成目标行业产品的产品需求文档PRD"
                            ]
                        }
                    ]
                },
                {
                    "stage": "第八阶段",
                    "title": "数据思维篇",
                    "phaseTargetList": [
                        "拥有数据思维，能够用数据优化产品",
                        "学习数据指标，掌握数据指标制定方法",
                        "掌握用漏斗分析法进行数据分析",
                        "拥有数据驱动产品增长的概念"
                    ],
                    "skillsList": {
                        "left": [
                            "剖析数据分析的核心意义",
                            "B、C端产品的数据应用场景",
                            "通过数据埋点获取产品数据",
                            "常见三种事件的数据埋点规范",
                            "实战：如何写一份合格的数据埋点文档",
                        ],
                        "right": [
                            "掌握产品三大数据业务指标",
                            "找到验证结果的数据业务指标",
                            "经典数据分析漏斗使用方法",
                            "如何拆解一个数据分析漏斗",
                            "拓展：成为数据驱动的增长黑客",
                        ]
                    },
                    "tips": [
                        "对目标行业产品的主要功能流程进行漏斗分析"
                    ],
                    "details": [
                        {
                            "t": "升维思考：锻炼产品经理的数据思维",
                            "desc": [
                                "剖析数据分析的核心意义",
                                "B、C端产品的数据应用场景"
                            ]
                        }, {
                            "t": "数据源头：如何进行产品数据采集",
                            "desc": [
                                "通过数据埋点获取产品数据",
                                "常见三种事件的数据埋点规范",
                                "如何写一份合格的数据埋点文档"
                            ]
                        }, {
                            "t": "有的放矢：监测产品关键性数据指标",
                            "desc": [
                                "掌握产品三大数据业务指标",
                                "找到验证结果的数据业务指标"
                            ]
                        }, {
                            "t": "拨云见日：用漏斗分析法进行数据分析",
                            "desc": [
                                "经典数据分析漏斗使用方法",
                                "如何拆解一个数据分析漏斗",
                                "拓展：成为数据驱动的增长黑客",
                            ]
                        }, {
                            "t": "实战应用",
                            "desc": [
                                "对目标行业产品的主要功能流程进行漏斗分析",
                            ]
                        }
                    ]
                },
                {
                    "stage": "第九阶段",
                    "title": "项目管理篇",
                    "phaseTargetList": [
                        "能够制定合理的项目排期方案",
                        "掌握项目管理三大环节实际应用方法",
                        "合理沟通，清楚合作岗位工作内容、工作难度、工作时间"
                    ],
                    "skillsList": {
                        "left": [
                            "项目核心三要素：成本、时间、范围",
                            "三大环节：质量管理、风险管理、进度管理",
                            "拓展：scrum敏捷开发加速项目推进",
                            "拓展：如何与开发、测试、UI高效沟通",
                            "拓展：产品经理应懂得技术知识",
                        ],
                        "right": [
                            "两个方向做好项目风险管理",
                            "产品验收的目的和核心事项",
                            "需求走查做好产品的质量验收",
                        ]
                    },
                    "tips": [],
                    "details": [
                        {
                            "t": "项目管理：让项目更好的推动落地",
                            "desc": [
                                "项目核心三要素：成本、时间、范围",
                                "三大环节：质量管理、风险管理、进度管理"
                            ]
                        }, {
                            "t": "了如指掌：如何做好项目进度管理",
                            "desc": [
                                "三加一做好项目进度管理",
                                "拓展：scrum敏捷开发加速项目推进",
                                "拓展：如何与开发、测试、UI高效沟通",
                                "拓展：产品经理应懂得技术知识"
                            ]
                        }, {
                            "t": "见时知几：及时预判项目中的风险",
                            "desc": [
                                "两个方向做好项目风险管理"
                            ]
                        }, {
                            "t": "全始全终：最关键的项目质量管理",
                            "desc": [
                                "产品验收的目的和核心事项",
                                "需求走查做好产品的质量验收"
                            ]
                        }
                    ]
                },
            ]
        },
    }
}
